import templateUrl from "emun.order/retailer-forms-popup.htm";
import RetailerFormsPopupController from "emun.order/retailer-forms-popup.controller";
import open from "webmodals/open";

let RetailerFormsPopup = options => {
	let modalInstance = open({
		size: options.size || "lg",
		templateUrl: options.templateUrl || templateUrl,
		controller: RetailerFormsPopupController,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => options
		}
	});

	return modalInstance.result;
};

export default RetailerFormsPopup;
